import { render } from "./SortableHeader.vue?vue&type=template&id=ab3b9f7a&scoped=true"
import script from "./SortableHeader.vue?vue&type=script&lang=js"
export * from "./SortableHeader.vue?vue&type=script&lang=js"

import "./SortableHeader.vue?vue&type=style&index=0&id=ab3b9f7a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab3b9f7a"]])

export default __exports__